import { useRef, useState, useEffect } from 'react';
import { SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Modal, Form, Select, Popconfirm, message } from 'antd';
import Highlighter from 'react-highlight-words';
import axios from 'axios';



const Menu = () => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [open, setOpen] = useState(false);
  const [iconValue, setIconValue] = useState('');
  const [typeValue, setTypeValue] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const  [error,setError] = useState();

  useEffect(() => {
    fetchMenuData();
  }, []);

  const fetchMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/menu`)
      .then(response => {
        const modifiedResponse = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));
        setData(modifiedResponse);
      })
      .catch(error => {
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
      });
  };

  

  

  const onFinish = values => {
    values.icon = iconValue ? iconValue : selectedRowData.icon;
    values.type = typeValue ? typeValue : selectedRowData.type;
  
    if (isEdit) {
      
      // Update existing menu item
      axios
        .patch(`${process.env.REACT_APP_API_URL}/menu/${selectedItemId}`, values)
        .then(response => {
          // console.log(response.data);
          fetchMenuData(); // Refresh the data after successful update
          message.success('Menu item edited successfully!');
        })
        .catch(error => {
          console.error(error.response.data.msg);
          // message.error(error.response.data.msg);
          setError(error.response.data.msg);
          setTimeout(function() {
            setError();
          }, 3000);
        });
    } else {
      // Create new menu item
      axios
        .post(`${process.env.REACT_APP_API_URL}/menu`, values)
        .then(response => {
          // console.log(response.data);
          fetchMenuData(); // Refresh the data after successful creation
          message.success('Menu item created successfully!');
        })
        .catch(error => {
          console.error(error.response.data.msg);
          // message.error(error.response.data.msg);
          setError(error.response.data.msg);
          setTimeout(function() {
            setError();
          }, 3000000);
        });
    }
  
    handleCancel();
  };
  

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const onChange = checked => {
    setLoading(!checked);
  };

  
  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };

  const handleCancel = () => {
    form.resetFields();
    setSelectedItemId(null);
    setSelectedRowData(null)
    setOpen(false);
  };

  const paginationConfig = {
    pageSize: 6,
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={e => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button type="link" size="small" onClick={() => close()}>
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '20%',
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      width: '10%',
      ...getColumnSearchProps('icon'),
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: '10%',
      ...getColumnSearchProps('type'),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: '20%',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button type="primary" icon={<EditOutlined />} onClick={() => handleEdit(record)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this menu item?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger" icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];
  

 
  

  const handleDelete = record => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}/menu/${record.uuid}`)
      .then(response => {
        fetchMenuData();
        message.success('Menu item deleted successfully');
      })
      .catch(error => {
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
      });
  };

 
  //// Onchange for Icon type selection

  const handleChange = (value) => {
    // console.log(`selected ${value}`);
    setIconValue(value)
  };

  //// Onchange for menu type selection

  const handleChangeType = (value) => {
    // console.log(`selected ${value}`);
    setTypeValue(value)
  };

  const showModal = () => {
    form.resetFields();
    setIsEdit(false);
    setSelectedRowData(null)
    setSelectedItemId(null);
    form.setFieldsValue({
      name: null,
      icon: null,
      type: null,
    });
    
    setOpen(true);
     // Clear the selected item ID
  };

  const handleEdit = record => {
    form.resetFields();
    setIsEdit(true);
    setSelectedItemId(record.uuid);
    setSelectedRowData(record);
    form.setFieldsValue({
      name: record.name,
      icon: record.icon,
      type: record.type,
    });
    setOpen(true);

  };



  return (
    <div className="depSubDept">
      {error && <div className='errorApi'>{error}</div>}
  
      <div>
        <div className="tableTitle">
          <h3>All Menu Items</h3>
          <Button type="primary" name='addItem' onClick={showModal}>
            Add Item
          </Button>
        </div>
        <Table columns={columns} dataSource={data} />
      </div>

      <Modal
      open={open}
      title="Add User"
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Return
        </Button>,
        <Button key="submit" type="primary" loading={loading} htmlType="submit" form="menuForm">
          Submit
        </Button>
      ]}
    >
      <Form
        name="basic"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 600,
        }}
         initialValues={selectedRowData}
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        id="menuForm" // Add an ID to the form
        
      >
        <Form.Item
          label="Menu Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Please input menu name!',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Menu Icon"
          name='icon'
          rules={[
            {
              required: true,
              message: 'Please select menu icon!',
            },
          ]}
        >
          <Select
            onChange={handleChange}
            allowClear
            options={[
              {
                value: 'PieChartOutlined',
                label: 'Pie',
              },
              {
                value: 'DesktopOutlined',
                label: 'Desktop',
              },
              {
                value: 'ContainerOutlined',
                label: 'Container',
              }
            ]}
          />

        </Form.Item>

        <Form.Item
          label="Menu Type"
          name="type"
          rules={[
            {
              required: true,
              message: 'Please select menu type!',
            },
          ]}
        >
          <Select
            onChange={handleChangeType}
            allowClear
            options={[
              {
                value: 'item',
                label: 'Item',
              },
            ]}
          />

        </Form.Item>

      </Form>
    </Modal>
    </div>
  );
};

export default Menu;
